import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { useAggregateMetric } from '../common/use-aggregate-metric';
import { ActionsArea } from './common/actions-area';
import { BackLine } from './common/backline';
import { ImpactSummaryAndRankArea } from './common/impact-summary-and-rank-area';
import { NetScores } from './common/net-scores';
import { TabletOrWiderOnly } from '@upright/ui/common/generic/layout/breakpoint-utils';

export function BottomBar(props: { scoreUnit: FinalImpactScoreType | undefined }) {
  const context = useNetImpactLensContext();
  const { aggregateMetric, setAggregateMetric, availableMetrics } = useAggregateMetric(props.scoreUnit);
  const options = context?.options;
  const hideNetScore = options?.hideNetScore;
  const showNetScore = !hideNetScore;

  return (
    <div>
      {showNetScore && <BackLine />}
      {showNetScore && (
        <ImpactSummaryAndRankArea
          scoreUnit={props.scoreUnit}
          currentMetric={aggregateMetric}
          setAggregateMetric={setAggregateMetric}
          availableMetrics={availableMetrics}
        />
      )}
      {showNetScore && (
        <NetScores
          scoreUnit={props.scoreUnit}
          currentMetric={aggregateMetric}
          setAggregateMetric={setAggregateMetric}
          availableMetrics={availableMetrics}
        />
      )}
      <TabletOrWiderOnly>
        <ActionsArea />
      </TabletOrWiderOnly>
    </div>
  );
}
